import React, { useState } from 'react';
import { TIME_FILTERS } from '../../data/constants';
import { classIf } from '../../data/utils/classIf';
import { getDayDesc } from '../../data/utils/getDayDesc';
import { labels } from '../../data/labels';
import { useFilters } from '../FiltersContext';
import { PrematchContext } from '../Prematch';

function processFilters(dayFilters) {
    dayFilters.forEach(d => {
        d.desc = getDayDesc(d.id);
        d.type = d.date;
    });
    return [
        {type: '1H', desc: labels['prematch_page.temporal_filters.1h'], hours: 1},
        {type: '3H', desc: labels['prematch_page.temporal_filters.3h'], hours: 3},
        {type: 'TODAY', desc: labels['prematch_page.temporal_filters.today'], days: 0},
        {type: '2D', desc: labels['prematch_page.temporal_filters.2d'], days: 1},
        {type: '3D', desc: labels['prematch_page.temporal_filters.3d'], days: 2},
        ...dayFilters,
        {type: 'ALL', desc: labels['prematch_page.temporal_filters.all'], hours: null}
    ];
}

function getDayMonth(date) {
    const day = date.substring(6, 8);
    const month = date.substring(4, 6);
    return `${day}.${month}`;
}

function LandingMenuNavbar(props) {
    const prematchContext = React.useContext(PrematchContext);
    const filters = useFilters();
    const [data] = useState(() => {
        const data = processFilters(filters);
        const timeFilters = [];
        const dayFilters = [];
        let allFilter = null;
        data.forEach(f => {
            if (TIME_FILTERS.includes(f.type)) {
                timeFilters.push(f);
            } else if (f.type !== 'ALL') {
                dayFilters.push(f);
            } else {
                allFilter = f;
            }
        });
        return {
            timeFilters,
            dayFilters,
            allFilter
        };
    });

    function handleClick(f) {
        prematchContext.setTemporalFilter(f);
        props.close();
    }

    return (
        <>
            <nav className="temporal-filters-sidebar">
                <span className="temporal-filter-tab tab-heading uppercase" onClick={() => window.openSection('live')}>Live</span>
                <span className="temporal-filter-tab tab-heading uppercase">{labels['general.hours_filters']}</span>
                {data &&
                    <>
                        {data.timeFilters.map((f, i) => {
                            const selected = prematchContext.temporalFilter.type === f.type;
                            return <span key={i} className={"temporal-filter-tab" + classIf(selected, 'selected')} onClick={() => handleClick(f)}><b>{f.desc}</b></span>;
                        })}
                        <span className="temporal-filter-tab tab-heading uppercase">{labels['general.days_filters']}</span>
                        {data.dayFilters.map((f, i) => {
                            const selected = prematchContext.temporalFilter.type === f.type;
                            return <span key={i} className={"temporal-filter-tab" + classIf(selected, 'selected')} onClick={() => handleClick(f)}><b className="day-desc">{f.desc}</b> &nbsp; {getDayMonth(f.date)}</span>;
                        })}
                        {data.allFilter &&
                            <span className={"temporal-filter-tab" + classIf(prematchContext.temporalFilter.type === data.allFilter.type, 'selected')} onClick={() => handleClick(data.allFilter)}><b>{data.allFilter.desc}</b></span>
                        }
                    </>
                }
            </nav>
        </>
    );
}

export default LandingMenuNavbar;